{
  "DELIVERY_PLUS_ADDRESS": "Leveransadress / adress",
  "CONDITIONS": "Villkor",
  "PRIMARY_CONTACT": "Kontakt",
  "PRH_PRISLISTABESKR": "Prislista",
  "XX_VALKOD": "Valuta",
  "X1_MOMSBESKRIVNING": "Moms",
  "FR_FTGLEVPOSTNR": "Lev. postnr",
  "X1K_LEVSATTBESKR": "Kundkategori",
  "KP_FTGPERSON": "Namn",
  "X1K_KUNDKATBESKR": "Kundkategori",
  "REF_CUSTOMER_CREATE_ERROR": "Fel vid skapande av kund.",
  "CUSTOMER_CREATE_FORM_ERROR": "Kundformuläret innehåller fel. Revidera fälten.",
  "CUSTOMER_CREATE_SUCCESS": "Kunden skapades i affärssystemet",
  "PROMOTIONS": "Kampanjer",
  "CARE": "Vård",
  "STYLING": "Styling",
  "PROFESSIONAL": "Professionell",
  "FR_FTGPOSTADR2_INVOICE": "Leveransadress (Faktura)",
  "FR_FTGPOSTADR1_INVOICE": "Ort (Faktura)",
  "FR_FTGPOSTNR_INVOICE": "Postnr (Faktura)",
  "FR_FTGPOSTADR3": "Ort (Faktura)",
  "MADE_A_PURCHASE_LAST_TWO_MONTHS": "Senaste två månaderna",
  "MADE_A_PURCHASE_LAST_FIVE_MONTHS": "Senaste fem månaderna",
  "CUSTOMER_CATEGORY": "Kundkategori",
  "VARUGRUPPSKOD": "Varugruppskod",
  "VOLUME": "Volym",
  "INACTIVE_CUSTOMERS": "Inaktiva kunder",
  "CHOOSE_TIMESPAN": "Välj tidsspan",
  "TWO_MONTHS": "Två månader",
  "FIVE_MONTHS": "Fem månader",
  "1_YEAR": "Ett år",
  "2_YEARS": "Två år",
  "PRODUCT_COMMODITY_GROUP": "Varugrupp",
  "EDIT_CUSTOMER": "Redigera kund",
  "UPDATE_CUSTOMER": "Uppdatera kund",
  "NOT_VALID_EMAIL": "Ej giltigt e-postmeddelande",
  "CUSTOMER_UPDATE_SUCCESS": "Kunden uppdaterad",
  "CUSTOMER_UPDATE_ERROR": "Fel vid uppdatering av kund.",
  "CUSTOMER_UPDATE_FORM_ERROR": "Uppdatera kundformuläret innehåller fel. Revidera fälten.",
  "DISPATCH_DATE": "Leveranstid",
  "DISPATCH_DATE_REQUIRED": "Leveransdatum krävs",
  "st": "pcs",
  "REF_DELIVERY_LOCATION_CHECKOUT_STEP_NEXT_BUTTON": "När du går vidare bekräftar du leveransplatsen",
  "REF_FH_FAKTURATYP_INVOICE": "Faktura",
  "REF_FH_FAKTURATYP_CREDIT": "Kreditera",
  "OH_ORDSTAT_12": "Kreditspärrad",
  "REF_KUNDKLASS": "Kundklass",
  "FR_FTGPOSTADR3_INVOICE": "Ort (Leverans)",
  "COST": "Kostnad",
  "MARKTING_EMAIL": "Marketing e-post",
  "INVOICE_EMAIL_ADDRESS": "Faktura e-post",
  "NEW_CUSTOMER_ORDER": "Ny kundorder"
}
